/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class DashboardContentProvider
 * @hideconstructor
 * @classdesc API provider class to create Dashboard ContentAPI instances
 */
define([
	'../../../../../canvas/DashboardContent',
	'../../../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../../../../../lib/@waca/dashboard-common/dist/api/ContentProviderAPI'
], (DashboardContent, APIFactory, ContentProviderAPI) => {

	class DashboardContentProvider {

		constructor({ features }) {
			this._api = APIFactory.createAPI(this, [ContentProviderAPI]);
			features['ContentFactory'].registerProvider(this._api);
		}

		getAPI() {
			return this._api;
		}

		getTypeList() {
			return ['dashboard'];
		}

		addModel() {
			throw new Error('Not supported.');
		}

		createContent(options) {
			return new DashboardContent(options);
		}

	}
	return DashboardContentProvider;
});
